export default __webpack_public_path__ + "static/media/imatge-slider-portada-3.72610901.jpg";